import axios from 'axios';
import { useInteraction } from 'react-interaction-hooks';

const headers = {
	'Content-Type': 'application/json',
	// 'Access-Control-Allow-Origin': process.env.REACT_APP_BACKEND_URL,
	// "Access-Control-Allow-Origin": "*"
};

export async function sendAPI(
	url: string,
	body?: any,
	openModal?: any,
	callback?: Function,
	callbackSuccess?: Function,
	callbackError?: Function,
	defaultMessage = '',
	isGet = false
) {
	callback = callback ? callback : () => {};
	callbackSuccess = callbackSuccess ? callbackSuccess : () => {};
	callbackError = callbackError ? callbackError : () => {};
	body = body ? body : {};

	// let urlHere = window.location.origin + '/api/' + url;
	// console.log("URL HERE: ", urlHere, body);
	let urlToPost = '/api/' + url;
	try {
		let mainResult = null;

		if (isGet) {
			mainResult = await axios
				.create({
					baseURL: '', //window.location.origin, //'api/' + process.env.REACT_APP_BACKEND_URL,
				})
				.get(urlToPost, {
					withCredentials: true,
					headers: headers,
				});
		} else {
			mainResult = await axios
				.create({
					baseURL: '', //window.location.origin, //'api/' + process.env.REACT_APP_BACKEND_URL,
				})
				.post(urlToPost, JSON.stringify(body), {
					withCredentials: true,
					headers: headers,
				});
		}

		if (mainResult && mainResult.data && mainResult.data.success) {
			if (mainResult.data.message) {
				if (openModal) {
					openModal(
						'Success',
						mainResult.data.message,
						'success',
						callback,
						callbackSuccess,
						callbackError
					);
				} else {
					callback();
				}
			}
			let data = { ...mainResult.data };
			if (mainResult?.headers['x-csrf-token']) {
				let xToken = mainResult.headers['x-csrf-token'];
				data['csrfToken'] = xToken;
			}

			return data;
		} else {
			if (mainResult.data.message) {
				if (openModal) {
					if (mainResult.data.redirectFrontpage) {
						callback = redirectToFrontpage.bind(this);
					}

					openModal('Warning', mainResult.data.message, 'error', callback);
				} else {
					callback();
				}
			}
			return mainResult.data;
		}
	} catch (ex: any) {
		if (openModal) {
			let errorMessage = 'Error came up while processing your request. Please contact administrator if this persists.';
			if (ex.response?.data) {
				if (typeof ex.response.data === 'string') {
					errorMessage += ' ' + ex.response.data;
				} else if (ex.response.data.message) {
					errorMessage += ' ' + ex.response.data.message;
				} else {
					errorMessage += ' ' + JSON.stringify(ex.response.data);
				}
			} else if (ex.message) {
				errorMessage += ' ' + ex.message;
			}
			openModal('Warning', errorMessage, 'error');
		}
		return {};
	}
}

export const submitFormMain = async (
	url: string,
	body: any,
	openModal: any,
	history: any,
	goBackAfterCreate: boolean
) => {
	// find out if create..

	let result = await sendAPI(url, body, openModal, null, () => {
		if (goBackAfterCreate && history) {
		} else {
		}
		// window.location.reload();
	});
};

export const onErrorMain = (openModal, message = '') => {
	openModal(
		'Error',
		message
			? message
			: 'There are errors in the form you must fix before submitting. ',
		'error'
	);
};

export const onObjectChange = (object, key, value, updateFunction) => {
	const newObject = Object.assign({}, object);
	newObject[key] = value;
	updateFunction(newObject);
};

export const onObjectChangeReturn = (object, key, value) => {
	const newObject = Object.assign({}, object);
	newObject[key] = value;
	return newObject;
	// updateFunction(newObject);
};

export async function onLogout(openModal, invalidate) {
	console.log('Starting logout process...');

	try {
		let result = await sendAPI('auth/logout', {}, openModal, () => {
			console.log('Logout callback triggered');
			setTimeout(() => {
				console.log('Reloading page after logout...');
				window.location.reload();
			}, 1500);
		});

		console.log('Logout result:', result);

		// Invalidate cache
		await invalidate();
		console.log('Cache invalidated');

		// Clear any remaining local storage/session storage
		try {
			localStorage.clear();
			sessionStorage.clear();
			console.log('Local storage cleared');
		} catch (e) {
			console.warn('Could not clear local storage:', e);
		}

		return result;
	} catch (error) {
		console.error('Logout error:', error);
		// Still try to clear local storage and reload even if API call fails
		try {
			localStorage.clear();
			sessionStorage.clear();
		} catch (e) {
			console.warn('Could not clear local storage in error case:', e);
		}

		// Force reload after a delay
		setTimeout(() => {
			window.location.reload();
		}, 1000);

		throw error;
	}
}

export function redirectToItemNewTab(route, id) {
	return () => {
		if (id) {
			const win = window.open(route + id, '_blank');
			win.focus();
		}
	};
}

export function redirectToFrontpage() {
	window.history.pushState('', '', '/');
}

export function removeItem(text, callback) {
	if (window.confirm(text)) {
		callback();
	}
}
